var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAndusFooterLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    role: "img",
    "aria-label": "LinkedIn",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.2 9.2v9M6.2 5.5v.2M10.3 18.2V9.3m0 3.9c.8-2.5 7.5-3.4 7.5 2.5v2.5m0-3.9V18",
    fill: "none",
    stroke: "#C8D2E0",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndusFooterLinkedin);
export default __webpack_public_path__ + "static/media/andus-footer-linkedin.eb4fce14d406c5faed216a1c144ec2be.svg";
export { ForwardRef as ReactComponent };